const sagaEvents = {
  fetchGame: 'fetchGame',
  handleInput: 'handleInput',
  handleSelect: 'handleSelect',
  addDirectory: 'addDirectory',
  loadDirectory: 'loadDirectory',
  handleSave: 'handleSave',
  loadSaves: 'loadSaves',
  reset: 'reset',
  check: 'check',
  solve: 'solve',
};

const events = {
  ...Object.fromEntries(
    Object.entries(sagaEvents)
      .map(([name, value]) => ([name, `saga/${value}`]))
  )
};

export default events;
